<div [ngClass]="[isInline ? 'flex h-full gap-3' : '']">
  <ng-container *ngTemplateOutlet="mainTemplate" />

  @if (isInline && isOpen) {
    <ng-container *ngTemplateOutlet="resizeHandleTemplate" />
    <ng-container *ngTemplateOutlet="panelTemplate" />
  }
</div>

<ng-template #mainTemplate>
  <div
    #featureContainer
    [ngClass]="isInline ? 'shrink grow overflow-auto' : ''"
  >
    @if (wrappedFeatureTemplateRef) {
      <ng-container *ngTemplateOutlet="wrappedFeatureTemplateRef" />
    }
  </div>
</ng-template>

<ng-template #panelTemplate>
  <div
    #panelContainer
    class="relative flex shrink grow flex-col overflow-auto bg-white"
    [ngClass]="[
      isOverlay ? 'max-w-[50vw] shadow-lg' : '',
      isInline ? 'w-[30vw] max-w-[50vw]' : '',
    ]"
  >
    <div class="flex items-center justify-between p-4">
      <h1 class="truncate text-lg font-medium">{{ label }}</h1>
      <p-button
        size="small"
        pTooltip="Close"
        tooltipPosition="left"
        severity="contrast"
        variant="text"
        (click)="close()"
      >
        <ng-template #icon>
          <svg-icon src="/assets/icons/general/close.svg" />
        </ng-template>
      </p-button>
    </div>

    @if (panelBodyTemplateRef) {
      <div class="grow overflow-auto px-4">
        <ng-container *ngTemplateOutlet="panelBodyTemplateRef" />
      </div>
    }

    @if (panelFooterTemplateRef) {
      <div class="absolute bottom-0 left-0 right-0 bg-white px-4">
        <ng-container *ngTemplateOutlet="panelFooterTemplateRef" />
      </div>
    }
  </div>
</ng-template>

<ng-template #resizeHandleTemplate>
  <!-- resize trigger -->
  <div
    #resizeHandle
    (mousedown)="onSidePanelResize($event)"
    class="group relative grid shrink-0 cursor-col-resize place-items-center px-1 transition-all"
  >
    <!-- resize border hover overlay -->
    <div
      class="absolute inset-y-0 left-[calc(50%-1px)] -translate-x-[calc(50%-1px)] bg-steel-blue-500 transition-all group-hover:w-0.5"
      [ngClass]="[isResizing ? 'w-0.5 cursor-col-resize' : '']"
    ></div>

    <!-- resize border -->
    <div class="h-full w-px bg-slate-300"></div>
  </div>
</ng-template>
